import React, { createContext, useContext, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../appState/appInitialState';
import { Exercise, Muscle } from '../types';

export interface GlobalDataContextProps {
  exercises: Record<string, Exercise>;
  muscles: Record<string, Muscle>;
}

const GlobalDataContext = createContext<GlobalDataContextProps>({
  exercises: {},
  muscles: {},
});

export const GlobalDataProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const exercises = useSelector((state: AppState) => state.exercises);
  const muscles = useSelector((state: AppState) => state.muscles);

  return (
    <GlobalDataContext.Provider value={{ exercises, muscles }}>
      {children}
    </GlobalDataContext.Provider>
  );
};

export const useGlobalData = () => {
  const context = useContext(GlobalDataContext);
  if (!context) {
    throw new Error('useGlobalData must be used within a GlobalDataProvider');
  }
  return context;
};
